module.exports = __webpack_public_path__ + "static/img/7.edd9722.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/2/zh/7.png
// module id = YId5
// module chunks = 0